import { hoursToSeconds } from 'utils/date';

export type Duration = number;

export interface DurationOption {
  value: Duration;
  label: string;
}

export const durationOptions: DurationOption[] = [4, 8, 24, 48, 72].map((hours) => ({
  value: hoursToSeconds(hours),
  label: `${hours}시간`,
}));
